import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import TransactionFormModal from '../../components/transactions/TransactionFormModal';

/**
 * Deep-link host for editing a transaction. The edit UX now lives in a modal;
 * this route opens that modal for the transaction in the URL and returns to the
 * transactions list when it closes.
 */
const EditTransactionPage = () => {
    const { id, orgId } = useParams();
    const navigate = useNavigate();

    const goToList = () => navigate(`/app/${orgId}/transactions`);

    return (
        <TransactionFormModal
            open
            transactionId={id}
            onClose={goToList}
        />
    );
};

export default EditTransactionPage;
